<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import { schema, meetings } from "./data";
import FormBuilder from "../../layouts/FormBuilder.vue";
import Heading from "../../layouts/heading";
import Swal from "sweetalert2";
import { v4 as uuidv4 } from 'uuid';
import api from "../../../api";

export default {
  props: {
    category: {},
    networkCmsId: null
  },
  page: {
    title: "News",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, FormBuilder, Heading },
  data() {
    return {
      value: null,
      topics: [],
      categorySelectValue: null,
      currentTopic: null,
      currentTopicData: {},
      currentTopicId: null,
      currentTopicActiveStatus: true,
      totalItem: 0,
      activeItem: 0,
      enabled: false,
      items: null,
      schema: schema,
      formData: {},
      page: {
        title: "News",
        lastUpdated: '31 Dec 2020 15:00',
        addNewBtn: true,
        addNewModalTitle: 'Add new Item',
        formData: {},
        schema: {
          name: {
            type: 'text',
            label: 'Name',
            placeholder: 'Enter Name',
            required: true,
            info: false,
            character_count: 50
          },
        },
        deleteBtn: true,
        activeBtn: true,
        submitBtn: false
      }, 
      submitted: false,
      form: {
        message: "",
      }
    };
  },
  methods: {
    selectedTopic(data) {
      this.currentTopicId = data.id
      this.currentTopicData = data
      this.currentTopic = {
        title: data.title,
        date: data.additionalProp1.date,
        description: data.description,
        image_url: data.additionalProp1.image_url,
        video_url: data.additionalProp1.video_url,
        featured: data.additionalProp1.featured
      }
    },
    async create(val) {
      if(!val) {
        return
      }
      const defaultSlug = val.name.replace(/\s/g, '').toLowerCase();
      var data = {
        uuid: uuidv4(),
        url: this.currentPractice.additionalProp1.url,
        active: true,
        title: val.name,
        picture: '',
        excerpt: 'Text here',
        description: '',
        deleted: false,          
        creationDate: new Date().toISOString(),
        lastModifiedDate: new Date().toISOString(),
        categoryId: this.category.id,
        cmsId: this.networkCmsId,
        additionalProp1: {
          date: '',
          image_url: '',
          video_url: '',
          slug: defaultSlug,
          categoryName: this.category.name,
          featured: false
        }
      };
      try {
        const response = await api.post('/api/categories/'+this.category.id+'/pages', data)
        this.createSlug(defaultSlug, response.data)
      } catch (error) {
        console.log(error)
      }
    },
    async createSlug(defaultSlug, page) {
      const data = {
        uuid: uuidv4(),
        name: defaultSlug,
        url: this.currentPractice.additionalProp1.url+'/'+defaultSlug,
        path: '/'+defaultSlug,      
        creationDate: new Date().toISOString(),
        lastModifiedDate: new Date().toISOString(),
        pageId: page.id,
        cmsId: this.networkCmsId,
        alertId: '',
        additionalProp1: {}
      };
      try {
        await api.post('/api/pages/'+page.id+'/slug', data)
        this.topics.push(page)
        Swal.fire("Item Added!", "Item Added Successfully!", "success");
      } catch (error) {
        console.log(error)
      }
    },
    async deleted() {
      var self = this;
      Swal.fire({
        title: `Are you sure you want to delete ${self.selectedItem.title}?`,
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, delete it!"
      }).then(result => {
        if (result.value) {
          api.delete('/api/pages/'+this.selectedItem.id)
          .then(() => {
            Swal.fire("Topic Deleted!", "Topic Deleted Successfully!", "warning");
            this.schema.tabs[0].side_panel.select_a_page.options
            .splice(
              this.schema.tabs[0].side_panel.select_a_page.options.findIndex(function(i){
              return i.id === self.selectedItem.id;
            }), 1);
            if(this.schema.tabs[0].side_panel.select_a_page.options.length == 0) {
              this.page.deleteBtn = false;
              this.page.activeBtn = false;
              this.$store.commit('updateOldFormData', new Object())
              this.$store.commit('updateCurrentFormData', new Object())
            }
          }, (error) => {
            console.log(error);
          });
        }
      });
    },
    async updateSlug(defaultSlug, pageId, page) {
      const data = {
        name: defaultSlug,
        url: this.currentPractice.additionalProp1.url+'/'+defaultSlug,
        path: '/'+defaultSlug,      
      };
      try {
        await api.patch('/api/pages/'+pageId+'/slug', data)
        Swal.fire("Topic Updated!", "Topic/Slug Updated Successfully!", "success");
        page.id = this.currentTopicId;
        this.selectedTopic(page)
        const objIndex = this.topics.findIndex((obj => obj.id === page.id));
        this.topics[objIndex] = this.currentTopicData
      } catch (error) {
        console.log(error)
      }
    },
    submit(val) {
      if(this.selectedTab == 'News'){
        var data = {
          title: val.title,
          description: val.description,
          url: val.path,
          active: this.currentTopicActiveStatus,
          additionalProp1: {
            featured: val.featured,
            date: val.date,
            media_type: val.upload_options,
            image_url: val.image_url,
            video_url: val.video_url,
            dynamoId: this.currentPractice.additionalProp1.dynamo,
          },
        };

        api.patch('/api/pages/'+val.id, data)
        .then(() => {
            const item = this.schema.tabs[0].side_panel.select_a_page.options.find(l => l.id == val.id)
            item.title = val.title;         
            item.description = val.description;         
            item.active = this.currentTopicActiveStatus;         
            item.additionalProp1.featured = val.featured;    
            item.additionalProp1.date = val.date;    
            item.additionalProp1.media_type = val.upload_options;    
            item.additionalProp1.image_url = val.image_url;    
            item.additionalProp1.video_url = val.video_url;    
            Swal.fire("Topic Updated!", "Topic Updated Successfully!", "success");
        }, (error) => {
          console.log(error);
        });
      }
    },
    activateToggle() {
      this.currentTopicActiveStatus = !this.currentTopicActiveStatus;
      var data = {
        active: this.currentTopicActiveStatus
      };
      api.patch('/api/pages/'+this.selectedItem.id, data)
      .then(() => {       
          let item = this.schema.tabs[0].side_panel.select_a_page.options.filter(l => l.id == this.selectedItem.id)[0];
          item.active = this.currentTopicActiveStatus;
          this.schema.tabs[0].side_panel.select_a_page.options.filter(l => l.id == this.selectedItem.id)[0] = item;
          this.$store.commit('updateOldFormData', item)
          this.$store.commit('updateCurrentFormData', item) 
          Swal.fire("Topic Status Updated!", "Topic Status Updated Successfully!", "success");
      }, (error) => {
        console.log(error);
      });
    },
    async getItem() {
      try {
        if (!this.category) {
          this.items = meetings
          console.log(this.items)
          return
        }
        const { data } = await api.get('/api/categories/'+this.category.id+'/pages')
        this.items = data
      } catch (error) {
        console.log(error)
      }
    },
    getPages() {
      api.get('/api/categories/'+this.category.id+'/pages')
      .then(response => {
        this.topics = response.data.sort((a, b) => a.additionalProp1.position - b.additionalProp1.position)
        this.schema.tabs[0].side_panel.select_a_page.options = this.topics;
        this.page = this.schema.tabs[0];   
        if(response.data.length == 0) {
          this.page.deleteBtn = false;
          this.page.activeBtn = false;
        }      
      })
      .catch(e => {
        console.log(e)
      })  
    },
    selectedItemFn(val) {
      this.selectedItem = val;
      this.currentTopicActiveStatus = val.active;
    },
    selectedTabFn(val) {
      this.selectedTab = val;
      this.topbar = this.page.tabs.filter(tab => tab.name == val)[0];
    },
  },
  watch: {
    currentCms() {
      this.$router.push({ name: 'Network' })    
    },
    currentTopic: function (val) {
      if(val != null)
      this.page.deleteBtn = true;
      this.currentTopicActiveStatus = this.currentTopicData.active;
    },
  },
  async mounted() {
    await this.getPages();
  }
}
</script>

<template>
  <Layout>
    <Heading :page="page" :activeStatus="currentTopicActiveStatus" @activateToggle="activateToggle"
    @created="create" @deleted="deleted" @form-submitted="submit"></Heading>
    <FormBuilder :schema="schema" :category="category" @selected-tab="selectedTabFn" @submit="submit" @selected-item="selectedItemFn" />
  </Layout>
</template>
<style scoped>
.border-right-dark {
  border-right: 1px solid #DADCE3;
}

.color-patientblue {
  color: #005EB8;
}
</style>